import { plural } from '@cian/utils/lib/shared/plural';

const DEFAULT_INTERVAL = 300;
const FAVICON_SIZE = 48;
const FAVICON_HREF = 'https://cian.ru/favicon.ico';

/**
 * Позволяет создать мигающий заголовок и поменять иконку на счетчик непрочитанных сообщений
 */
export class BlinkingTitleSingleton {
  private static instance: BlinkingTitleSingleton;
  private originalTitle: string;
  private headElement: HTMLHeadElement;
  private favicon: HTMLElement | null;
  private timeoutID: any;
  private title: string;
  private count: number;
  private faviconCount: number;
  private faviconCanvasData: string;
  private isVisibleCounter: boolean;

  private constructor() {
    this.timeoutID = null;
    this.originalTitle = `${document.title}`;
    this.favicon = document.getElementById('favicon');
    this.headElement = document.getElementsByTagName('head')[0];
    this.title = '';
    this.count = 0;
    this.faviconCount = 0;
    this.faviconCanvasData = '';
    this.isVisibleCounter = false;

    this.checkMainFavicon();
  }

  public static getInstance(): BlinkingTitleSingleton {
    if (!BlinkingTitleSingleton.instance) {
      BlinkingTitleSingleton.instance = new BlinkingTitleSingleton();
    }

    return BlinkingTitleSingleton.instance;
  }

  private checkMainFavicon = () => {
    if (!this.favicon) {
      const favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.id = 'favicon';
      favicon.href = FAVICON_HREF;
      this.headElement.appendChild(favicon);

      this.favicon = favicon;
    }
  };

  private resetFavicon = () => {
    if (this.favicon) {
      this.favicon.setAttribute('href', FAVICON_HREF);
    }
  };

  private drawCounter = (count: number) => {
    if (!this.favicon) {
      return;
    }
    const countFormat = count > 99 ? `99+` : count.toString();
    const canvas = document.createElement('canvas');
    canvas.width = FAVICON_SIZE;
    canvas.height = FAVICON_SIZE;

    const context = canvas.getContext('2d');
    const img = document.createElement('img');

    if (!context) {
      return;
    }

    // Риусет пустое изобрадение
    context.drawImage(img, 0, 0, FAVICON_SIZE, FAVICON_SIZE);

    // Рисует синий круг
    context.beginPath();
    const radius = FAVICON_SIZE / 2;
    context.arc(canvas.width - radius, radius, radius, 0, 2 * Math.PI);
    context.fillStyle = '#0468ff';
    context.fill();

    // Рисует количество сообщений в круге
    context.font = '24px Lato, Arial, sans-serif';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillStyle = '#FFFFFF';
    context.fillText(countFormat, canvas.width - radius, radius);

    // Сохраняет картинку в переменную
    this.faviconCanvasData = canvas.toDataURL('image/png');
    this.faviconCount = count;
  };

  private changeDocumentInfo = () => {
    this.isVisibleCounter = !this.isVisibleCounter;

    // подменяет заголовок
    if (this.isVisibleCounter) {
      document.title = this.title;
    } else {
      document.title = this.originalTitle;
    }

    // подменяет иконку
    this.changeFavicon();

    if (this.timeoutID) {
      window.clearTimeout(this.timeoutID);
    }

    this.timeoutID = window.setTimeout(this.changeDocumentInfo, DEFAULT_INTERVAL);
  };

  private resetTitle = () => {
    document.title = this.originalTitle;
    this.title = '';
  };

  private changeFavicon = () => {
    if (!this.favicon) {
      this.checkMainFavicon();
    }

    if (!this.favicon) {
      return;
    }

    if (this.isVisibleCounter) {
      if (this.count !== this.faviconCount || !this.faviconCanvasData) {
        this.drawCounter(this.count);
      }

      this.favicon.setAttribute('href', this.faviconCanvasData);
    } else {
      this.resetFavicon();
    }
  };

  private resetFaviconData = () => {
    this.resetFavicon();
    this.faviconCanvasData = '';
    this.faviconCount = 0;
  };

  public setBlinkingDocumentInfo(count: number) {
    this.title = `${count} ${plural(count, ['новое сообщение', 'новых сообщения', 'новых сообщений'])}`;
    this.count = count;
    this.changeDocumentInfo();
  }

  public resetDocumentInfo() {
    this.isVisibleCounter = false;
    this.resetTitle();
    this.resetFaviconData();

    if (this.timeoutID) {
      window.clearTimeout(this.timeoutID);
    }
  }
}
